import { call, put, select, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'setup/axiosInstance';
import { mineActions } from 'features/feedback/store/mine.slice';
import { FeedbackTO, Page } from 'features/feedback/shared/feedback.types';

export function* fetchMineSaga(action: ReturnType<typeof mineActions.mineGet>) {
  try {
    const tab = action.payload;
    const params: Record<string, unknown> = { page: 0, size: 50 };
    if (tab && tab !== 'ALL') params.type = tab;
    const resp: AxiosResponse<Page<FeedbackTO>> = yield call(axiosInstance.get, '/feedback/mine', { params });
    yield put(mineActions.mineSet(resp.data));
  } catch (e) {
    console.error(e);
    yield put(mineActions.mineError());
  }
}

export function* deleteMineSaga(action: ReturnType<typeof mineActions.deleteItem>) {
  const id = action.payload;
  const snapshot: FeedbackTO | null = yield select((s: any) => s.mine.lastDeleted);
  try {
    yield call(axiosInstance.delete, `/feedback/${id}`);
  } catch (e) {
    console.error(e);
    if (snapshot) yield put(mineActions.deleteRollback(snapshot));
  }
}

export default function* mineSaga() {
  yield takeLatest(mineActions.mineGet, fetchMineSaga);
  yield takeLatest(mineActions.deleteItem, deleteMineSaga);
}
